/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuotaHistoryResponseFromJSON, QuotaResponseFromJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class QuotaApi extends runtime.BaseAPI {
    /**
     * Get current user quota information.  Triggers lazy quota reset if the period has expired.  Returns:     dict: Quota usage and limits
     * Get Quota
     */
    async getQuotaV1QuotaGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/quota`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => QuotaResponseFromJSON(jsonValue));
    }
    /**
     * Get current user quota information.  Triggers lazy quota reset if the period has expired.  Returns:     dict: Quota usage and limits
     * Get Quota
     */
    async getQuotaV1QuotaGet(initOverrides) {
        const response = await this.getQuotaV1QuotaGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get usage history for current user.  Args:     limit: Maximum number of records to return (default: 50)  Returns:     dict: List of usage records
     * Get Usage History
     */
    async getUsageHistoryV1QuotaHistoryGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/quota/history`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => QuotaHistoryResponseFromJSON(jsonValue));
    }
    /**
     * Get usage history for current user.  Args:     limit: Maximum number of records to return (default: 50)  Returns:     dict: List of usage records
     * Get Usage History
     */
    async getUsageHistoryV1QuotaHistoryGet(requestParameters = {}, initOverrides) {
        const response = await this.getUsageHistoryV1QuotaHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
